module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-wrap"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "height": ".4rem"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "package-sorting"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(1)
      }
    }
  }, [_c('b', [_vm._v("青年版 (17-44周岁)")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(2)
      }
    }
  }, [_c('b', [_vm._v("中年版 (45-60周岁)")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "touchstart": function($event) {
        _vm.goPpayment(3)
      }
    }
  }, [_c('b', [_vm._v("老年版 (60周岁以上)")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": ".59rem"
    }
  })])]), _vm._v(" "), _c('myheader')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("1111")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("2222")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("3333")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._v("4444")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a71886e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/phonecomponents/home.vue
// module id = 762
// module chunks = 1